import { PropertiesPanel } from 'src/components/pages/productConfiguration/steps/configurator-components/scene-properties-panel';
import React, { FC, useMemo } from 'react';
import { CameraConfigHelpers, CameraNode, CameraProperty, useCameraPropertiesCreator } from '../cameraEditorConfig';
import InspectorShell from '../inspectorShell';

// L'involucro sta in `InspectorShell`, uno per tutti i generi: qui resta ciò che è solo di
// una camera.

export interface CameraOverlayProps {
    camera: {
        id: string;
        name: string;
        position: [number, number, number];
        target: [number, number, number];
        fov: number;
        isActive: boolean;
        enableZoomLimit: boolean;
        // Proprietà zoom
        useMinZoomPerc: boolean;
        useMaxZoomPerc: boolean;
        minZoomPerc: number;
        maxZoomPerc: number;
        // Proprietà rotazione
        lowerBetaLimits: number | undefined;
        upperBetaLimits: number | undefined;
        lowerAlphaLimit: number | undefined;
        upperAlphaLimit: number | undefined;
        height: number;
        autoRotate: boolean;
    };
    onPropertyChange: (property: CameraProperty, value?: any) => void;
}

const CameraSettingOverlayComponent: FC<CameraOverlayProps> = ({ camera, onPropertyChange }) => {
    // Hook per creare le proprietà della camera
    const createCameraProperties = useCameraPropertiesCreator();

    // Crea gli helpers per la configurazione delle proprietà
    const helpers: CameraConfigHelpers = useMemo(
        () => ({
            onPropertyChange
        }),
        [onPropertyChange]
    );

    // Genera le proprietà usando il factory pattern
    const properties = useMemo(() => {
        return createCameraProperties(camera as CameraNode, helpers);
    }, [createCameraProperties, camera, helpers]);

    // QUESTO PANNELLO NON È DI UNA CAMERA: sono le impostazioni che valgono per tutte, perché il
    // motore le tiene sulla scena. Il marchio lo dice al plurale.
    //
    // E LE SPECIFICHE NON CI SONO PIÙ. Dicevano «FOV 1°», ed era falso due volte: il numero è
    // quello della scena e non di una camera, e non è un grado — `setCameraPositionFOV` scrive il
    // campo visivo di Babylon, che è in RADIANTI. Un radiante mostrato come un grado sono
    // cinquantasette gradi di differenza.
    return (
        <InspectorShell kind='cameras' name={camera.name}>
            <PropertiesPanel properties={properties} />
        </InspectorShell>
    );
};

export default CameraSettingOverlayComponent;
